import React from 'react';
import PropTypes from 'prop-types';

function IconCheck({ size = 10, color = `#88898B`, className, style }) {
  return (
    <svg width={size} height={size} className={className} style={style} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.33332 2.5L3.74999 7.08333L1.66666 5" stroke={color} strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconCheck.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconCheck;
